import { createEntityAdapter } from '@reduxjs/toolkit';

import type { VehicleOrderDetailsApiResponse } from '../../../common/models/vehicleOrders.model';

//adapters for vehicle orders
export const vehicleOrdersAdapter =
  createEntityAdapter<VehicleOrderDetailsApiResponse>({
    selectId: (order: VehicleOrderDetailsApiResponse) => order?.code,
  });
